import React from 'react';
import PropTypes from 'prop-types';

export default function UnreadIndicator({ active, size = 8, color = '#ff5252' }) {
  if (!active) return null;

  const dimension = `${size}px`;

  return (
    <span
      aria-label="未讀消息提示"
      style={{
        display: 'inline-block',
        width: dimension,
        height: dimension,
        borderRadius: '50%',
        backgroundColor: color,
        marginLeft: '8px',
        flexShrink: 0
      }}
    />
  );
}

UnreadIndicator.propTypes = {
  active: PropTypes.bool.isRequired,
  size: PropTypes.number,
  color: PropTypes.string
};
